import React from 'react'
import './notfound.style.css'
import {useTranslation} from 'react-i18next'
import BunnySvg from '../../../assets/svgs/bunnyEmpty.svg'

export const NotfoundScreen = () => {
    const {t} = useTranslation(['tracking'])

    return (
        <div data-cy={'notFoundDiv'} className={'container notfound-cntr'}>
            <div className={'notfound-404 primary'}>404</div>
            <div className={'notfound-txt black45'}>{t('notfound')}</div>
            <img alt={'notfound'} src={BunnySvg}/>
        </div>
    )
}